import Vue from 'vue';

export default {
  state: () => ({
    tooltipList: {},
  }),

  mutations: {
    mutateAddTooltip(state, { token, tooltip }) {
      Vue.set(state.tooltipList, token, tooltip);
    },

    mutateDeleteTooltip(state, token) {
      Vue.delete(state.tooltipList, token);
    },

    mutateSetTooltipVisibility(state, { token, status }) {
      if (state.tooltipList[token] && typeof state.tooltipList[token] === 'object') {
        state.tooltipList[token].isVisible = status;
      }
    },
  },

  namespaced: true,
};
